module.exports = __webpack_public_path__ + "img/pShop-banner.b12220cd.jpg";